import { render, staticRenderFns } from "./studentCreate.vue?vue&type=template&id=6d6b2340&scoped=true&"
import script from "./studentCreate.vue?vue&type=script&lang=ts&"
export * from "./studentCreate.vue?vue&type=script&lang=ts&"
import style0 from "./studentCreate.vue?vue&type=style&index=0&id=6d6b2340&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6b2340",
  null
  
)

export default component.exports